import React from "react";

const Income = () => {
  return <h1>Income</h1>;
};

export default Income;
